/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryfilterall3Inputs */

const en_medialibraryfilterall3 = /** @type {(inputs: Medialibraryfilterall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const de_medialibraryfilterall3 = /** @type {(inputs: Medialibraryfilterall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Medialibraryfilterall3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryfilterall3 = /** @type {((inputs?: Medialibraryfilterall3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryfilterall3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryfilterall3(inputs)
	return de_medialibraryfilterall3(inputs)
});
export { medialibraryfilterall3 as "mediaLibraryFilterAll" }